import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api } from "../../redux/reducers/apiSlice";
import { clearToken } from "../../redux/reducers/authSlice";
import { customConsole } from "../utils/helper";
import * as Sentry from "@sentry/react";

const useSignout = () => {

    let navigate = null;

    try {
        navigate = useNavigate();
    } catch(e){
        customConsole("log", "Not a router component")
    }
    
    const dispatch = useDispatch();

    const signOut = async () => {
        try {
          
            if(navigate){
                navigate("/");
            } else {
                window.location.href="/"
            }
          dispatch(api.util.resetApiState());
          dispatch(clearToken()) // resetting api after calling Auth.signout will break
          await Auth.signOut();
        } catch (error) {
          Sentry.captureException(error);
          customConsole("log", "error signing out: ", error);
        }
      };

    return {
        signOut
    }
}

export default useSignout